<script setup lang="ts">
import { withDefaults } from 'vue'

const emit = defineEmits<{
  (event: 'onClickTitle'): void
}>()

const props = withDefaults(
  defineProps<{
    enabled?: boolean
    expanded?: boolean
    icon?: any
    title?: string
  }>(),
  {
    enabled: false
  }
)
</script>

<template>
  <div
    v-if="props.title || props.icon"
    :class="`flex items-center py-2 ${
      !props.enabled
        ? 'text-gray-400 fill-gray-400'
        : 'dark:text-gray-300 fill-sky-500 dark:fill-sky-400 cursor-pointer'
    }`"
    @click="emit('onClickTitle')"
  >
    <component v-if="props.icon" :is="props.icon" class="w-8 h-8 mr-4" />
    <div>{{ props.title }}</div>
  </div>
  <Transition name="fade">
    <div v-if="props.expanded">
      <slot />
    </div>
  </Transition>
</template>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s ease-out;
  max-height: 1000px;
  overflow: hidden;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  max-height: 0;
}
</style>
